<template>
    <div class="mt-3">
        <div class="overflow-x-auto">
            <table class="w-full">
                <tbody>
                    <template
                        v-if="paginator && paginator.results && paginator.results.length !== 0"
                    >
                        <template
                            v-for="newLoyer of paginator.results" :key="newLoyer.uuid"
                        >
                            <NewLoyerItem :newLoyer="newLoyer" @refresh="loadNewLoyer" />
                        </template>

                    </template>
                    <tr
                        class="px-2 py-3 border-t border-gray-200"
                        v-else-if="!loaded"
                    >
                        <td colspan="5">
                            <SpinnerLoader class="mt-5"></SpinnerLoader>
                        </td>
                    </tr>
                    <tr
                        class="px-2 py-3 border-t border-gray-200"
                        v-else
                    >
                        <td colspan="5" class="text-center">
                            <p class="text-sm text-indigo-400 my-4">Vous n'avez aucun loyer à valider.</p>
                        </td>
                    </tr>
                </tbody>
            </table>
            <PaginationBlock class="mt-2" v-if="paginator && paginator.total > 0" :paginator="paginator" @changePage="changePage"/>
        </div>
    </div>
</template>

<script>

import SpinnerLoader from './../../loader/SpinnerLoader';
import PaginationBlock from './../../composant/PaginationBlock';
import NewLoyerItem from './../../dashboard/new-loyer/NewLoyerItem';

export default {
    components: {
        SpinnerLoader,
        PaginationBlock,
        NewLoyerItem
    },

    data() {
        return {
            paginator: {
                results: []
            },
            loaded: false,
            addLoader: false,
            form: {
                year: new Date().getFullYear(),
                amount: null,
                paiementDate: null
            },
            formInvalid: [],
        }
    },

    created() {
        this.loadNewLoyer()
    },

    methods: {
        async changePage(page) {
            await this.loadNewLoyer(page)
        },

        async loadNewLoyer(page = 1) {
            this.loaded = false
            this.paginator.results = []

            this.paginator = await this.$api.dashboard.getNewLoyers(page);

            this.loaded = true
        },
    }
};
</script>
